import { useEffect } from "react";

type Props = {
  message: string;
  onDone?: () => void;
  durationMs?: number;
};

export function Toast({ message, onDone, durationMs = 2800 }: Props) {
  useEffect(() => {
    const t = window.setTimeout(() => onDone?.(), durationMs);
    return () => window.clearTimeout(t);
  }, [message, onDone, durationMs]);

  return (
    <div className="toast" role="status" aria-live="polite" aria-atomic="true">
      {message}
    </div>
  );
}
